var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-row',{staticStyle:{"padding":"10px"}},[_vm._v("Custom Fields")]),_c('vs-row',_vm._l((_vm.customFields),function(field,index){return _c('vs-col',{key:index,staticStyle:{"padding":"10px"},attrs:{"vs-lg":"6","vs-sm":"6","vs-xs":"6"}},[_c('FieldValue',{attrs:{"field":field}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }